import script from "./mesDevisView.vue?vue&type=script&setup=true&lang=js"
export * from "./mesDevisView.vue?vue&type=script&setup=true&lang=js"

import "./mesDevisView.vue?vue&type=style&index=0&id=e65d5f12&lang=scss&scoped=true"

import exportComponent from "/home/pilki/freelaix/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e65d5f12"]])

export default __exports__